import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';

import Modal from '../../../ui/Modal';

import { useContext } from '../Context';

export default function UnlockModal({ show, onHide }) {
  const { dispatch, actions, state } = useContext();

  const [loader, setLoader] = useState(false);

  const onUnlockClicked = () => {
    setLoader(true);
    actions.unlockPolicy(
      dispatch,
      state.enterpriseId,
      state.policy.id,
      () => {
        setLoader(false);
        toastr.info('Policy unlocked.');
        onHide();
      },
    );
  };

  return (
    <Modal show={show} onHide={onHide} header="Unlock Policy">
      <p className="text-danger">{state.policy.attributes.lock_reason_human}</p>
      <p>
        Click "Unlock" to prevent cancellation, or "Close" to exit this window.
      </p>
      <div className="mt50 mb30">
        <Row>
          <Col md={6}>

            <button
              type="button"
              onClick={() => onHide()}
              className="btn btn-primary btn-outline mr5 ml5 width-120"
            >
              Close
            </button>

          </Col>
          <Col md={6} className="text-right">
            <button
              className={`btn width-120 btn-primary submit-button mr5 ml5 ${loader ? 'not-possible-click' : ''}`}
              type="submit"
              onClick={onUnlockClicked}
            >
              Unlock
            </button>

          </Col>
        </Row>
      </div>
    </Modal>
  );
}
